module.exports = __webpack_public_path__ + "static/media/pin_dottor_grandine.f42eee77.png";